import React from 'react';
import { Settings, FileText, Globe, TrendingUp, Star, Layout } from 'lucide-react';

const PopularSearches = () => {
  return (
    /* 1. 'w-full' aur 'bg-[#f8f9fa]' ensures ki background solid rahe */
    /* 2. 'py-12' footer aur dashboard ke beech gap rakhega */
    <div className="w-full bg-[#f8f9fa] min-h-screen py-12 px-4 md:px-10 font-sans">
      
      {/* Main Dashboard Container */}
      <div className="max-w-7xl mx-auto bg-white rounded-[3rem] p-8 md:p-12 shadow-xl border border-gray-100">
        
        {/* Navigation inside Dashboard */}
        <nav className="flex justify-between items-center mb-12">
          <div className="flex items-center gap-2">
            <div className="bg-[#2e7d32] p-1.5 rounded-lg shadow-md">
              <Layout className="text-white w-5 h-5" />
            </div>
            <span className="text-xl font-bold text-[#37474f]">Trady Frog</span>
          </div>
          <div className="hidden md:flex gap-8 text-sm font-semibold text-gray-400">
            <span className="hover:text-green-600 cursor-pointer">License</span>
            <span className="hover:text-green-600 cursor-pointer">Purity</span>
            <span className="hover:text-green-600 cursor-pointer">Wallet</span>
            <span className="hover:text-green-600 cursor-pointer">Press</span>
          </div>
        </nav>

        {/* Header Title */}
        <div className="mb-12">
          <h1 className="text-4xl font-extrabold text-[#37474f] relative inline-block">
            Popular Searches
            <div className="absolute -bottom-2 left-0 w-full h-1.5 bg-[#2e7d32] rounded-full"></div>
          </h1>
        </div>

        {/* Dashboard Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          
          {/* Left Side */}
          <div className="space-y-10">
            {/* Trending Card */}
            <div className="bg-white p-6 rounded-[2.5rem] border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex justify-between items-center mb-6">
                <h3 className="font-bold text-gray-700">Trending Searches</h3>
                <Settings size={16} className="text-gray-300" />
              </div>
              <div className="bg-green-50/50 rounded-3xl p-10 text-center border border-dashed border-green-200">
                <div className="flex items-center justify-center gap-4">
                  <span className="text-3xl font-black text-[#2e7d32]">Smart 4 Searches</span>
                  <div className="flex items-center text-white bg-green-600 px-3 py-1 rounded-full text-sm font-bold shadow-sm">
                    <TrendingUp size={14} className="mr-1" /> 141
                  </div>
                </div>
              </div>
            </div>

            {/* Featured Suppliers Icons */}
            <div className="bg-white p-6 rounded-[2.5rem] border border-gray-100 shadow-sm">
              <div className="flex justify-between items-center mb-6">
                <h3 className="font-bold text-gray-700">Featured Suppliers</h3>
                <Settings size={16} className="text-gray-300" />
              </div>
              <div className="grid grid-cols-4 gap-4 mb-6">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className={`aspect-square rounded-full border-2 flex items-center justify-center transition-all ${i === 0 ? 'border-green-500 bg-green-50 scale-110 shadow-sm' : 'border-gray-100'}`}>
                    <FileText size={20} className={i === 0 ? 'text-green-600' : 'text-gray-300'} />
                  </div>
                ))}
              </div>
              <div className="bg-gray-50 p-4 rounded-2xl text-xs text-gray-500 flex items-center gap-2 border border-gray-100 font-medium">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                Featured along with Dolls & Industrial Parts
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="space-y-10">
            {/* Supplier Profiles */}
            <div className="bg-white p-6 rounded-[2.5rem] border border-gray-100 shadow-sm">
              <div className="flex justify-between items-center mb-6">
                <h3 className="font-bold text-gray-700">Featured Suppliers</h3>
                <Settings size={16} className="text-gray-300" />
              </div>
              <div className="flex justify-between gap-4">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="text-center flex-1 group">
                    <div className="overflow-hidden rounded-2xl mb-3 border-2 border-white shadow-sm group-hover:border-green-200 transition-all">
                      <img src={`https://i.pravatar.cc/150?u=tech${i+50}`} className="w-full aspect-square object-cover" alt="user" />
                    </div>
                    <div className="flex justify-center gap-0.5 mb-1">
                      {[...Array(5)].map((_, s) => <Star key={s} size={10} className="fill-yellow-400 text-yellow-400" />)}
                    </div>
                    <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">PEERTREE</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Supplier List */}
            <div className="bg-white p-6 rounded-[2.5rem] border border-gray-100 shadow-sm">
              <div className="flex justify-between items-center mb-6">
                <h3 className="font-bold text-gray-700">Top Raised Suppliers</h3>
                <Settings size={16} className="text-gray-300" />
              </div>
              <div className="space-y-4">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-2xl transition-colors cursor-pointer group">
                    <div className="flex items-center gap-3">
                      <img src={`https://i.pravatar.cc/150?u=list${i+30}`} className="w-10 h-10 rounded-full border border-gray-100 shadow-sm" alt="avatar" />
                      <span className="text-sm font-bold text-gray-700 group-hover:text-green-600 transition-colors">Supplier Name {i}</span>
                    </div>
                    <span className="text-[10px] font-mono font-bold text-gray-300">S00{i}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularSearches;